import { h } from 'preact';
import * as BaseComp from 'components/bolt/movieDetails/movieDetails.js';
import { getTTSizeOverride } from 'utils/bolt';
import { joinClasses } from 'utils/utils';
import * as webp from 'utils/bolt/webp';
import s from 'components/bolt/movieDetails/movieDetails.sss';
import { navigateInternally } from 'utils/bolt';

export default class MovieDetails extends BaseComp.default {	
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick = () => {
		setTimeout(() => {
			navigateInternally('outcastQuiz');
		}, 100);
	};
	
	renderTT(tt = {}) {
		let { type, visible, hide } = this.props;
		let ttStyle;
		if (type === 'homeEnt') {
			type = 'showtimes';
		}
		// use hide specifically when you need it to fade out instead of disappear
		const ttSrc = this.getTT(tt);
		const ttSize = getTTSizeOverride(tt);
		const ttPos = this.getTTPosition(tt);
		const ttRightOrLeft = ttPos === 'right' || ttPos === 'left';

		if (ttSize) {
			ttStyle = {
				width: ttSize.maxWidth ? (ttRightOrLeft ? 'auto' : '100%') : null,
				height: ttSize.maxHeight ? '100%' : null,
				maxWidth: ttSize.maxWidth,
				maxHeight: ttSize.maxHeight
			};
		}
		if (!ttSrc) {
			return;
		}

		const fallbackFormat = this.getFallbackFormat('tt');
		const copy = this.props.copy;
		return (
			<webp.Picture
				style={ttStyle}
				class={joinClasses(s.tt, s[type], visible && s.visible, hide && s.hide)}
				alt={copy.accessibilityCopy[tt.alt] || tt.alt}
				src={ttSrc}
				fallbackFormat={fallbackFormat}
				key="tt"
				onClick={() => this.handleClick()}
			/>
		
		);
	}

}
